import { GetServerSidePropsContext, NextPage } from 'next/types';

import SubscriptionWrapper from 'src/components/subscriptions/SubscriptionWrapper';
import SubscriptionWrapperNew from 'src/components/subscriptions/SubscriptionWrapperNew';
import SubscriptionWrapperV4 from 'src/components/subscriptions/SubscriptionWrapperV4';
import { BannerAPIContentType } from 'src/services/responseTypes/BannerApiResponse';
import { Data } from 'src/services/responseTypes/displayPlansResponse';
import {
  SubscriptionResponse,
  SubscriptionResponseV2
} from 'src/types/subscription';
import { HTTP_URL_PARAMS } from 'src/utils/constants/HttpMethodsConstants';
import {
  CONSUMPTION_LANGUAGE_FROM_WEBAPP,
  PREVIOUS_CONSUMPTION_PAGE_LANGUAGES
} from 'src/utils/constants/localStorageConstants';
import {
  FeatureFlagConstants,
  REMOTE_CONFIG
} from 'src/utils/constants/utilConstants';
import {
  clearCookieOnServer,
  getCookieDataOnServerSide
} from 'src/utils/cookieHelper';
import { getFeatureFlagConfig } from 'src/utils/RemoteConfig';
import {
  getNewSubscriptionProps,
  getV2SubscriptionProps
} from 'src/utils/SubscriptionHelper/serverSideProps';
import { getSubscriptionVariant } from 'src/utils/SubscriptionHelper/SubscriptionHelper';

import SimpleStore from '../../store/SimpleStore';
type Props = {
  bannerImages: BannerAPIContentType[];
  firstBannerImageUrl: string;
  plansData: Data;
  plansDataNew: SubscriptionResponse;
  variant: string;
  plansDataV2: SubscriptionResponseV2.Response;
};
const defaultVariant = 'v2';

const Subscription: NextPage<Props> = (props) => {
  const variant = props.variant;
  if (variant === 'v3') return <SubscriptionWrapperV4 {...props} />;
  return <SubscriptionWrapperNew {...props} />;
};
export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const remoteConfig = SimpleStore.get(REMOTE_CONFIG);
  const res = context.res;
  const country = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
  const config = getFeatureFlagConfig(
    remoteConfig,
    FeatureFlagConstants.CONFIG_NEW_SUBSCRIPTION_UI
  );
  // const config = {
  //   enabled: true,
  //   payload: {
  //     'name': 'v3',
  //     'enabledForIndia': true,
  //     'enabledForGlobal': true,
  //     'global': 'some',
  //     'countries': ['US']
  //   }
  // }
  const requestHeaders = context?.req?.headers || {};
  const cookieData = requestHeaders?.cookie as string;
  const prevConsumptionPageLanguage =
    getCookieDataOnServerSide(
      cookieData,
      PREVIOUS_CONSUMPTION_PAGE_LANGUAGES
    ) ||
    getCookieDataOnServerSide(cookieData, CONSUMPTION_LANGUAGE_FROM_WEBAPP) ||
    '';
  clearCookieOnServer(res, PREVIOUS_CONSUMPTION_PAGE_LANGUAGES);
  clearCookieOnServer(res, CONSUMPTION_LANGUAGE_FROM_WEBAPP);
  const variant = getSubscriptionVariant({ config, country });
  const serverProps =
    variant === 'v3'
      ? await getV2SubscriptionProps(context, prevConsumptionPageLanguage)
      : await getNewSubscriptionProps(context);
  return {
    props: {
      ...serverProps.props,
      variant,
      prevConsumptionPageLanguage
    }
  };
};

export default Subscription;
